(function () {
  var STYLE_ID = 'hs-jdgm-styles';

  var CSS = [
    /* ── 评论卡片 ── */
    '.jdgm-rev{',
      'border-radius:10px!important;',
      'box-shadow:0 2px 10px rgba(59,42,26,.09)!important;',
      'padding:20px!important;',
      'border:1px solid rgba(59,42,26,.12)!important;',
      'transition:box-shadow .2s!important;',
      'margin-bottom:0!important;',
    '}',
    '.jdgm-rev:hover{box-shadow:0 6px 22px rgba(59,42,26,.16)!important}',
    '.jdgm-rev+.jdgm-rev{border-top:none!important}',

    /* ── 评星颜色 ── */
    '.jdgm--on,.jdgm-star.jdgm--on{color:#E8A020!important}',
    '.jdgm--off,.jdgm-star.jdgm--off{color:#D8CEBF!important}',

    /* ── Write a Review 按钮 ── */
    '.jdgm-write-rev-btn{',
      'background:#C9893D!important;',
      'border:none!important;',
      'border-radius:6px!important;',
      'color:#fff!important;',
      'font-weight:600!important;',
      'letter-spacing:.03em!important;',
      'padding:10px 22px!important;',
      'cursor:pointer!important;',
    '}',
    '.jdgm-write-rev-btn:hover{background:#a96f28!important}',

    /* ── Verified 徽章 ── */
    '.jdgm-badge-verified,.jdgm-rev__badge{',
      'background:rgba(201,137,61,.1)!important;',
      'border:1px solid rgba(201,137,61,.3)!important;',
      'border-radius:999px!important;',
      'color:#C9893D!important;',
      'padding:2px 9px!important;',
      'font-size:11px!important;',
      'font-weight:500!important;',
    '}',

    /* ── 评论文字 ── */
    '.jdgm-rev__title{font-size:15px!important;font-weight:700!important;color:#1C1009!important}',
    '.jdgm-rev__body{font-size:13.5px!important;line-height:1.7!important;color:#3a2a1c!important}',
    '.jdgm-rev__timestamp{font-size:12px!important;color:#7A6858!important}',

    /* ── 自定义问答 ── */
    '.jdgm-cf-question,.jdgm-custom-field__label{font-size:11.5px!important;color:#7A6858!important;font-weight:400!important}',
    '.jdgm-cf-answer,.jdgm-custom-field__answer{font-size:13px!important;font-weight:600!important;color:#1C1009!important}',

    /* ── 评分直方图 ── */
    '.jdgm-histogram__bar-fill{background:#E8A020!important;border-radius:2px!important}',
    '.jdgm-histogram__bar-bg{background:#EDE5DA!important;border-radius:2px!important}',

    /* ── 评论图片 ── */
    '.jdgm-rev__pic-link img,.jdgm-rev__pic img{border-radius:6px!important;border:1.5px solid rgba(59,42,26,.1)!important;object-fit:cover!important}',

    /* ── 手机端 ── */
    '@media(max-width:767px){',
      '.jdgm-write-rev-btn{width:100%!important;display:block!important;text-align:center!important;margin-bottom:12px!important}',
      '.jdgm-rev{padding:14px!important}',
      '.jdgm-rev__body{font-size:13px!important}',
      '.jdgm-rev-widg__header{flex-wrap:wrap!important}',
    '}',
  ].join('');

  function inject() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    document.head.appendChild(el);
  }

  /* 若 widget 已经在 DOM 里则立即注入 */
  function alreadyLoaded() {
    return !!(
      document.querySelector('.jdgm-widget') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('[class^="jdgm-"]')
    );
  }

  if (alreadyLoaded()) {
    inject();
    return;
  }

  /* 否则用 MutationObserver 等待 Judge.me 渲染完成 */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (
          node.classList && (
            node.classList.contains('jdgm-widget') ||
            node.classList.contains('jdgm-rev-widg') ||
            node.querySelector('.jdgm-widget, .jdgm-rev-widg')
          )
        ) {
          inject();
          observer.disconnect();
          return;
        }
      }
    }
    /* 兜底：只要出现任何 jdgm- 类就触发 */
    if (alreadyLoaded()) {
      inject();
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* 最终兜底：页面 load 完还没触发则强制注入 */
  window.addEventListener('load', function () {
    inject();
    observer.disconnect();
  });
})();
